export const removeSpecificQueryParams = (paramsToRemove, router) => {
    const updatedQuery = { ...router.query };
    paramsToRemove.forEach(param => {
      delete updatedQuery[param];
    });

    router.replace(
      {
        pathname: router.pathname,
        query: updatedQuery,
      },
      undefined,
      { shallow: true }
    );
  };